<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Kits'"
      :newRowmodalButtonText="'Novo Kit'"
      :tableHeader="headers"
      :tableRows="listaKits"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="modalInsert"
      v-on:datatable-updaterow="modalUpdate"
      v-on:datatable-deleterow="modalDelete"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.modalSize"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="eventoDeAcao"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal
            :tipo="alertaModal.tipo"
            :texto="alertaModal.texto"
          ></AlertasModal>
        </v-col>
      </v-row>

      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12" lg="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.nomeKit"
              name="nomeKit"
              label="Nome do Kit"
              :rules="[rules.required, rules.limitCharacters]"
              counter="255"
              autocomplete="off"
            ></v-text-field>
          </v-col>

          <v-col cols="12" lg="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.descricaoKit"
              name="descricaoKit"
              label="Descrição do Kit"
              counter="255"
              autocomplete="off"
            ></v-text-field>
          </v-col>

          <v-col cols="12" lg="12">
            <v-autocomplete
              label="Produtos Padronizados"
              :items="listaItensSistemaUnidade"
              v-model="itemSelecionado"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="12">
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                ></v-text-field>
              </v-card-title>

              <v-data-table
                :headers="headersItens"
                :search="search"
                :items="modalCustomSize.actualEdit.itensKit"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template
                  v-if="!modalCustomSize.isView"
                  v-slot:[`item.quantidade`]="props"
                >
                  <v-text-field
                    style="max-width:250px"
                    v-model="props.item.quantidade"
                    :rules="[rules.required]"
                    label="Quantidade Padrão"
                    single-line
                    @keypress="event => filter(event)"
                  ></v-text-field>
                </template>

                <template
                  v-if="!modalCustomSize.isView"
                  v-slot:[`item.actions`]="{ item }"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        @click="deleteItemFromList(item)"
                        v-bind="attrs"
                        v-on="on"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>

    <DeleteItemModal
      :textModalDelete="customModalDelete.textModalDelete"
      :showModalDelete="customModalDelete.modalOpen"
      :buttomTextModalDelete="'Excluir'"
      v-on:close-modal="customModalDelete.modalOpen = false"
      v-on:on-response-modal-delete="deleteAction"
    ></DeleteItemModal>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DataTable2";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import DeleteItemModal from "../components/DeleteItemModal";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    SkeletonTable,
    Alertas,
    AlertasModal,
    AlertaSnackbar
  },

  data: () => ({
    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: v => v && v.length <= 255 || 'Limite de 255 caracteres.'
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red"
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    showSkeletonTable: true,
    loading: false,
    isFormValid: false,
    search: "",

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID Kit",
        value: "kit.numeroKit",
      },
      {
        text: "Nome do Kit",
        value: "kit.nomeKit",
      },
      {
        text: "Descrição do Kit",
        value: "kit.descricaoKit",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "numeroItemSistemaUnidade",
      },
      {
        text: "Nome Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Qt. que deseja padronizar a retirada (Digite Abaixo)",
        value: "quantidade",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        numeroKit: null,
        nomeKit: null,
        descricaoKit: null,
        itensKit: [],
        itensKitExcluidos: [],
        descricaoTela: "kit"
      },
    },

    customModalDelete: {
      modalOpen: null,
      textModalDelete: "Você realmente deseja deletar esse Kit?",
      descricaoTela: "kit",
      actionDelete: {
        numeroKit: null,
        itensKit: []
      }
    },

    //Array populado pela função initialize
    listaKits: [],
    listaItensSistemaUnidade: [],
    itemSelecionado: null
  }),

  created() {
    this.initialize();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },

    itemSelecionado() {
      if (this.itemSelecionado) {
        this.alertaModal.tipo = "";
        const verificarItem = this.modalCustomSize.actualEdit.itensKit.filter(
          (item) => item.numeroItemSistemaUnidade == this.itemSelecionado
        );

        if (verificarItem.length <= 0) {
          const itemInsert = this.listaItensSistemaUnidade.filter(
            (item) => item.numeroItemSistemaUnidade == this.itemSelecionado
          );

          this.modalCustomSize.actualEdit.itensKit.unshift(itemInsert[0]);
          this.itemSelecionado = "";
          this.modalCustomSize.isButtonsDisabled = true;
        } else {
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.mostrar = true;
        }
      }
    }
  },

  methods: {
    async initialize() {
      this.showSkeletonTable = true;
      try {
        let response = await axios.put("kits", { numeroEndereco: store.state.numeroEndereco }, this.config);
        
        this.listaKits = response.data;
      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.showSkeletonTable = false;
      }
    },

    async listaItensEstoqueUnidade() {
      try {
        let response = await axios.put("itemSistemaUnidade", { numeroEndereco: store.state.numeroEndereco }, this.config);
        
        this.listaItensSistemaUnidade = response.data.map(itemSelecionado => {
          return {
            value: itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: itemSelecionado.itemSistema.nomeItemSistema,
            
            numeroItemSistemaUnidade: itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
            nomeItemSistema: itemSelecionado.itemSistema.nomeItemSistema
          }
        });
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    //#region Eventos de Ação e Requisição
    async eventoDeAcao() {
      this.modalCustomSize.isButtonsDisabled = true;
      try {
        if (this.modalCustomSize.isEdit) {
          await this.update(this.modalCustomSize.actualEdit);
        } else {
          await this.insert(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error)
        this.modalCustomSize.isOpen = true;
      } finally {
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    async insert(reciveItem) {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.post("insertKit", reciveItem, this.config);

        this.modalCustomSize.isOpen = false;
        this.initialize();
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.put("updateKit", reciveItem, this.config);

        this.modalCustomSize.isOpen = false;
        this.initialize();
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async deleteAction() {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.delete("deleteKit", {
          data: this.customModalDelete.actionDelete,
          headers: this.config.headers,
        });

        this.initialize();
      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.customModalDelete.modalOpen = false;
      }
    },
    //#endregion

    //#region Funções de edit dialog da datatable
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Alterada a Quantidade Padrão";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Cancelado edição";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar Quantidade Padrão";
    },
    close() {
      console.log("Dialog closed");
    },
    deleteItemFromList(value) {
      value.quantidade = null;
      this.modalCustomSize.actualEdit.itensKitExcluidos.push(
        this.modalCustomSize.actualEdit.itensKit.filter(
          (item) => item.numeroItemSistemaUnidade == value.numeroItemSistemaUnidade
        )
      );

      this.modalCustomSize.actualEdit.itensKit = this.modalCustomSize.actualEdit.itensKit.filter(
        (item) => item.numeroItemSistemaUnidade != value.numeroItemSistemaUnidade
      );

      if (this.modalCustomSize.actualEdit.itensKit.length == 0) {
        this.modalCustomSize.isButtonsDisabled = true;
      }
    },
    //#endregion

    async modalInsert() {
      this.loading = true
      try {
        await this.listaItensEstoqueUnidade()

        this.modalCustomSize.actualEdit.nomeKit = null;
        this.modalCustomSize.actualEdit.descricaoKit = null;
        this.modalCustomSize.actualEdit.itensKit = [];
        this.modalCustomSize.actualEdit.itensKitExcluidos = [];
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Novo Kit";
        this.modalCustomSize.isOpen = true;
        this.loading = false
      }
    },

    async modalUpdate(kitSelecionado) {
      this.loading = true
      try {
        await this.listaItensEstoqueUnidade()

        const response = await axios.put("itensKit", {numeroKit: kitSelecionado.kit.numeroKit}, this.config)
        
        this.modalCustomSize.actualEdit.itensKit = response.data;
        this.modalCustomSize.actualEdit.itensKitExcluidos = [];

        this.modalCustomSize.actualEdit.numeroKit = kitSelecionado.kit.numeroKit;
        this.modalCustomSize.actualEdit.nomeKit = kitSelecionado.kit.nomeKit;
        this.modalCustomSize.actualEdit.descricaoKit = kitSelecionado.kit.descricaoKit;
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Atualizar Kit";
        this.modalCustomSize.isOpen = true;
        this.loading = false
      }
    },

    async modalDelete(kitSelecionado) {
      try {
        const response = await axios.put("itensKit", {numeroKit: kitSelecionado.kit.numeroKit}, this.config)

        this.customModalDelete.actionDelete.itensKit = response.data;
        this.customModalDelete.actionDelete.numeroKit = kitSelecionado.kit.numeroKit;
      } catch (error) {
        console.log(error)
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.customModalDelete.modalOpen = true;
      }
    },

    filter: function(evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      
      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
};
</script>
